module.exports = __webpack_public_path__ + "img/main_header_bgimg.b9f51a68.jpg";